import React from 'react'
import { isDw2Repaint } from '../../../../../../experiments/dw2Repaint'
import T3MoneyOverPanel from './t3-money-overpanel'
import T3VariantOverPanel from './t3-variant-overpanel'

const T3MoneyPage = props => {
  return isDw2Repaint() ? (
    <T3VariantOverPanel {...props} />
  ) : (
    <T3MoneyOverPanel {...props} />
  )
}

export default T3MoneyPage
